import api from './api';

export const settingsService = {
  // Profile
  getProfile: (kodeCabang = 'PUSAT') => 
    api.get('/settings/profile', { params: { kodeCabang } }),
  
  updateProfile: (data) => 
    api.put('/settings/profile', data),

  // Pengurus
  getPengurus: () =>
    api.get('/settings/pengurus'),

  getJabatanEnum: () =>
    api.get('/settings/pengurus/jabatan-enum'),

  createPengurus: (data) =>
    api.post('/settings/pengurus', data),
  
  updatePengurus: (id, data) => 
    api.put(`/settings/pengurus/${id}`, data),
  
  deletePengurus: (id) => 
    api.delete(`/settings/pengurus/${id}`),

  // System Config
  getSystemConfig: () => 
    api.get('/settings/config'),
  
  updateSystemConfig: (data) => 
    api.put('/settings/config', data),

  // Cabang
  getCabang: () => 
    api.get('/settings/cabang'),

  // COA
  getCOA: (tipe) =>
    api.get('/settings/coa', { params: { tipe } }),

  saveCOA: (data) =>
    api.post('/settings/coa', data),

  // SHU Settings
  getSHUSettings: (tahun) =>
    api.get(`/shu/settings/${tahun}`),

  updateSHUSettings: (tahun, data) =>
    api.put(`/shu/settings/${tahun}`, data),

  // Lingkungan / Area
  getLingkungan: (params = {}) => 
    api.get('/lingkungan', { params }),
  
  getLingkunganByKode: (kode) => 
    api.get(`/lingkungan/${kode}`),
  
  createLingkungan: (data) => 
    api.post('/lingkungan', data),
  
  updateLingkungan: (kode, data) => 
    api.put(`/lingkungan/${kode}`, data),
  
  deleteLingkungan: (kode) => 
    api.delete(`/lingkungan/${kode}`)
};
